<template>
    <div>      
        <div class="container">
             <div class="table">
                <el-checkbox-group v-model="checkedIds" @change="handleCheckedIdsChange">
                    <table>
                        <thead>
                        <tr class="th">
                            <td></td>
                            <td>品牌</td>
                            <td>货号</td>
                            <td>包装单位</td>
                            <td>纯度</td>
                            <td>库存</td>
                            <td>产品描述</td>
                            <td>价格（ RMB ）</td>
                            <td>购买数量</td>
                            <td>操作</td>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in cartList" :key="index">
                                <td class="checkbox">
                                    <el-checkbox :label="item.id"></el-checkbox>
                                </td>
                                <td>{{item.brandName}}</td>
                                <td>{{item.specsNo}}</td>
                                <td>{{item.packingUnit}}</td>
                                <td>{{item.purity}}</td>
                                <td>{{ item.deliver }}</td>
                                <td>{{item.specsDesc}}</td>
                                <td>
                                    <span style="color: #ff9236;">{{ item.discountMoney}}</span>
                                    <span
                                        style="color: #999; text-decoration: line-through; font-size: 12px; margin-left: 5px;"
                                    >{{item.originalMoney}}</span>
                                </td>
                                <td>
                                    <el-input-number
                                        v-model="item.amount"
                                        @change="cartNmChange(item)"
                                        size="mini"
                                        :min="1"
                                        :max="10"
                                        label="描述文字"
                                    ></el-input-number>
                                </td>
                                <td>
                                    <el-button
                                        type="danger"
                                        size="mini"
                                        @click="deleteCart(item)"
                                    >删除</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </el-checkbox-group>
                <div class="table-empty" v-if="cartList.length === 0">
                    <i class="el-icon-document-copy"></i>
                    <p>暂无数据</p>
                </div>
            </div>
        </div>

        <div class="container">
             <div class="orderSubmitDiv">
                <div class="first">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                    >全选</el-checkbox>
                </div>

                <div class="sec" id="deleteAll" @click="batchDelete">批量删除</div>
                <div class="sec" @click="clearShopCart">清空购物车</div>

                <div
                    class="pressbutton"
                    :class="{'opacity': checkedIds.length === 0}"
                    @click="handleOrder"
                >确认结算</div>
                <div class="desc1">（不包含运费）</div>
                <div class="price">￥{{amount}}</div>
                <div class="desc">总价</div>
                <div class="am">共 {{num}} 件商品</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

import { mapActions } from 'vuex';

export default {
    name: 'ShopCartDiv',
    data() {
        return {
            checkAll: false,
            checkedIds: [],
            isIndeterminate: false,
            cartList: [],
            num: 0,
            amount: 0,
        };
    },
    methods: {
        ...mapActions(['setreloadUserState']),
        handleCheckAllChange(val) {
            this.checkedIds = val ? this.cartList.map(item => item.id) : [];
            this.isIndeterminate = false;
            this.getAmount();
        },
        handleCheckedIdsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cartList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cartList.length;
            this.getAmount();
        },
        getCartList() {
            apis.getCartList().then(res => {
                this.cartList = res;
                this.getAmount();
            });

            this.setreloadUserState(true);
        },
        clearShopCart() {
            apis.clearCart().then(res => {
                this.checkedIds = [];
                this.handleCheckedIdsChange(this.checkedIds);
                this.getCartList();
                this.handleCheckAllChange();
            });
        },
        deleteCart(item) {
            apis.batchDeleteCart(item.id).then(res => {
                if (this.checkedIds.indexOf(item.id) > -1) {
                    const index = this.checkedIds.findIndex(id => item.id === id);
                    this.checkedIds.splice(index, 1);
                    this.handleCheckedIdsChange(this.checkedIds);
                }
                this.getCartList();
            });
        },
        batchDelete() {
            const ids = this.checkedIds.join(',');
            apis.batchDeleteCart(ids).then(res => {
                this.checkedIds = [];
                this.handleCheckedIdsChange(this.checkedIds);
                this.getCartList();
            });
        },
        cartNmChange(item) {
            if (item.amount === 0) {
                apis.batchDeleteCart(item.id).then(res => {
                    this.getCartList();
                });
            } else {
                apis.addToCart(item.specsId, item.amount).then(res => {
                    this.getCartList();
                });
            }
        },
        getAmount() {
            const cartList = this.checkedIds.map(id => this.cartList.find(cart => cart.id === id));
            this.num = cartList.reduce((prve, item) => {
                return prve + item.amount;
            }, 0);
            this.amount = cartList
                .reduce((prve, item) => {
                    return prve + item.discountMoney.replace(',', '') * item.amount;
                }, 0)
                .toFixed(2);
        },
        handleOrder() {
            if (this.checkedIds.length === 0) {
                return;
            }
            this.$router.push({
                path: '/sub-order',
                query: { ids: this.checkedIds.join(',') },
            });
        },
    },
    mounted() {
        this.getCartList();
    },
};
</script>

<style scoped lang="less">
.el-checkbox-group {
    font-size: inherit;
}
.checkbox label {
    width: 20px;
    height: 100%;
    overflow: hidden;
}

.orderSubmitDiv {
    margin-top: 20px;
    height: 80px;
    background-color: #fff;
    line-height: 80px;
}

.orderSubmitDiv .first {
    width: 100px;
    float: left;
    color: #6b6b6b;
    font-size: 13px;
    margin-left: 20px;
}

.orderSubmitDiv .sec {
    width: 100px;
    float: left;
    color: #6b6b6b;
    font-size: 13px;
    cursor: pointer;
}

.orderSubmitDiv .pressbutton {
    float: right;
    text-align: center;
    line-height: 80px;
    cursor: pointer;
    color: #fff;
    width: 222px;
    height: 80px;
    background-color: #3c9539;
}
.orderSubmitDiv .pressbutton.opacity {
    opacity: 0.3;
}

.orderSubmitDiv .price {
    float: right;
    height: 70px;
    color: #ff9236;
    font-size: 26px;
}

.orderSubmitDiv .desc1 {
    float: right;
    color: #bdbdbd;
    font-size: 12px;

    margin-right: 20px;
}

.orderSubmitDiv .desc {
    height: 70px;
    float: right;
    color: #6b6b6b;
    font-size: 14px;
}

.orderSubmitDiv .am {
    width: 90px;
    height: 70px;
    float: right;
    color: #6b6b6b;
    font-size: 14px;
}

.table {
    background-color: #fff;
    position: relative;
    table {
        position: relative;
        z-index: 1;
        .th {
           // background: transparent;
        }
    }
}
.table::after {
    content: '';
    width: 100%;
    height: 52px;
    background-image: linear-gradient(90deg, #6db231 0%, #37923a 100%);
    position: absolute;
    top: 0;
    left: 0;
}
</style>

